<template>
  <div class="tab-content">
    <!-- 基本信息内容 -->
    <div class="security-user-info-section">

      <!-- 测试人员区域 -->
      <div class="info-area">
        <div class="security-user-wrapper">
          <h3 class="security-user">安全员信息</h3>
        </div>
        <div class="security-user-detail-container">
          <div v-for="(user, index) in securityUsers" :key="index" class="security-user-edit-section">
            <div class="security-user-header">
              <span class="security-user-index">安全员 {{ index + 1 }}</span>
            </div>
            <div class="security-user-edit-row">
              <div class="security-user-detail-item">
                <span class="security-user-detail-label">姓名：</span>
                <span class="security-user-detail-value">{{ user.name || '-' }}</span>
              </div>
              <div class="security-user-detail-item">
                <span class="security-user-detail-label">性别：</span>
                <span class="security-user-detail-value">{{ user.gender === 1 ? '男' : user.gender === 0 ? '女' : '-' }}</span>
              </div>
            </div>
            <div class="security-user-edit-row">
              <div class="security-user-detail-item">
                <span class="security-user-detail-label">联系方式：</span>
                <span class="security-user-detail-value">{{ user.phone || '-' }}</span>
              </div>
              <div class="security-user-detail-item">
                <span class="security-user-detail-label">身份证号码：</span>
                <span class="security-user-detail-value">{{ user.idCard || '-' }}</span>
              </div>
            </div>
            <div class="security-user-edit-row">
              <div class="security-user-detail-item">
                <span class="security-user-detail-label">驾驶证号：</span>
                <span class="security-user-detail-value">{{ user.licenseNumber || '-' }}</span>
              </div>
              <div class="security-user-detail-item">
                <span class="security-user-detail-label">培训日期：</span>
                <span class="security-user-detail-value">{{ user.trainingDate || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup name="BasicInfoTab">
import { defineProps, ref, onMounted } from 'vue';
import { getSecurityUserListByApplicationId } from "@/api/application/applicationVehicles";
import useAppStore from "@/store/modules/app";

const appStore = useAppStore();

const props = defineProps({
  id: {
    type: String,
    required: true
  }
});

// 测试人员数据
const securityUsers = ref([]);

const applicationSecurityUserList = async () => {
  const res = await getSecurityUserListByApplicationId(props.id);
  if (res.code === 200 && res.data){
    securityUsers.value = Array.isArray(res.data) ? res.data : (res.data ? [res.data] : []);
  }
}

// 组件挂载时获取数据
onMounted(async () => {
  try {
    await applicationSecurityUserList(props.id);
  } catch (error) {
    console.error('获取安全员信息失败:', error);
  }
});
</script>

<style scoped>
.tab-content {
  background: #fff;
  margin-bottom: 80px;
}

.security-user-info-section {
  background: #fff;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
}

.info-area {
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
}

.security-user-wrapper {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #d9d9d9;
}

.security-user {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.security-user-detail-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.security-user-edit-section {
  margin-bottom: 16px;
  padding: 16px 20px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  width: 100%;
  max-width: 800px;
}

.security-user-header {
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #d9d9d9;
}

.security-user-index {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.security-user-edit-row {
  display: flex;
  margin-bottom: 16px;
  gap: 16px;
  justify-content: space-between;
}

.security-user-edit-row:last-child {
  margin-bottom: 0;
}

.security-user-detail-item {
  display: flex;
  align-items: center;
  width: 380px;
}

.security-user-detail-label {
  font-weight: 500;
  color: #666;
  min-width: 130px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}

.security-user-detail-value {
  color: #333;
  text-align: left;
  flex: 1;
}
</style>